export default "__VITE_ASSET__C_vuIKpL__"